import React from 'react';
import Index from './pages/Index';
import Create from './pages/Create';
import Edit from './pages/Edit';
import { AppRouteProps } from '~/routes';

export default function DocumentTypeRoutes(): readonly AppRouteProps[] {
  const routes: AppRouteProps[] = [
    {path: '/document-type', component: Index, isProtected: true, permissions: ['document_type_index']},
    {path: '/document-type/create', component: Create, isProtected: true, permissions: ['document_type_create']},
    {path: '/document-type/edit/:id', component: Edit, isProtected: true, permissions: ['document_type_edit']},

  ];

  return routes;
}
